import { useTranslation } from 'react-i18next';

import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { type GetDealsListQuery } from '@/lib/graphql/generated/graphql';
import { DEAL_TABS, TAB_COUNT_KEYS } from '@/states/deals-list.state';

export function DealsTabs({
  counts,
}: {
  counts: GetDealsListQuery['listDeals']['counts'] | undefined;
}) {
  const { t } = useTranslation();
  return (
    <TabsList aria-label={t('deals-list.title')}>
      {DEAL_TABS.map((value) => (
        <TabsTrigger key={value} value={value}>
          {t(`deals-list.tabs.${TAB_COUNT_KEYS[value]}`)}
          <span className="ml-2 text-muted-foreground">
            {counts?.[TAB_COUNT_KEYS[value]] ?? '—'}
          </span>
        </TabsTrigger>
      ))}
    </TabsList>
  );
}
